// class CartEvenItemsDrawer extends HTMLElement {
//   constructor() {
//     super();
//     this.lastOpenedAt = 0;
//     this.checkoutClickTimeout = null;
//   }

//   connectedCallback() {
//     document.addEventListener("ajaxProduct:added", () => {
//       // Vibrate when product added
//       this.triggerVibration(200);

//       setTimeout(() => {
//         const cartBubble = document.querySelector(".cart-count-bubble span[aria-hidden='true']");
//         if (!cartBubble) return;

//         const itemCount = parseInt(cartBubble.textContent.trim());
//         const now = Date.now();

//         // Only open drawer if even count and not opened in last 2 seconds
//         if (itemCount > 0 && itemCount % 2 === 0 && now - this.lastOpenedAt > 2000) {
//           const summary = document.querySelector("cart-drawer")?.querySelector("summary");
//           if (summary && !summary.closest("details")?.hasAttribute("open")) {
//             summary.click();
//             // Stronger vibration when drawer opens
//             this.triggerVibration(300);
//             this.lastOpenedAt = now;
//           }
//         }
//       }, 50);
//     });
//   }

//   triggerVibration(duration) {
//     // Try Vibration API first
//     if (navigator.vibrate) {
//       navigator.vibrate(duration);
//     } else if (navigator.webkitVibrate) {
//       navigator.webkitVibrate(duration);
//     } else if (navigator.mozVibrate) {
//       navigator.mozVibrate(duration);
//     } else if (navigator.msVibrate) {
//       navigator.msVibrate(duration);
//     } else {
//       // Fallback: Use Web Audio API for haptic feedback simulation
//       this.audioVibration(duration);
//     }
//   }

//   audioVibration(duration) {
//     try {
//       const audioContext = new (window.AudioContext || window.webkitAudioContext)();
//       const oscillator = audioContext.createOscillator();
//       const gain = audioContext.createGain();

//       oscillator.connect(gain);
//       gain.connect(audioContext.destination);

//       oscillator.frequency.value = 200;
//       gain.gain.setValueAtTime(0.1, audioContext.currentTime);
//       gain.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + duration / 1000);

//       oscillator.start();
//       oscillator.stop(audioContext.currentTime + duration / 1000);
//     } catch (e) {
//       // Silent fail if audio context fails
//     }
//   }
// }

// customElements.define("cart-even-items-drawer", CartEvenItemsDrawer);

// // ====================================
// // OPTIMIZED ENHANCED VERSION
// // ====================================

// class CartEvenItemsDrawerEnhanced extends HTMLElement {
//   constructor() {
//     super();
//     this.lastOpenedAt = 0;
//     this.vibrationAPI = this.getVibrationAPI();
//     this.handleProductAdded = this.handleProductAdded.bind(this);
//   }

//   connectedCallback() {
//     this.initToastContainer();
//     this.observeCartDrawerMenu();
//     document.addEventListener("ajaxProduct:added", this.handleProductAdded, { passive: true });
//   }

//   disconnectedCallback() {
//     document.removeEventListener("ajaxProduct:added", this.handleProductAdded);
//   }

//   initToastContainer() {
//     if (!document.querySelector(".toast-container")) {
//       const container = document.createElement("div");
//       container.className = "toast-container";
//       container.setAttribute("aria-live", "polite");
//       document.body.appendChild(container);
//     }
//   }

//   observeCartDrawerMenu() {
//     const cartDrawerContainer = document.querySelector(".cart-drawer-container");
//     if (!cartDrawerContainer) return;

//     const toastContainer = document.querySelector(".toast-container");

//     // Create a MutationObserver to watch for class changes
//     const observer = new MutationObserver(() => {
//       if (cartDrawerContainer.classList.contains("menu-opening")) {
//         toastContainer.style.zIndex = "1";
//       } else {
//         toastContainer.style.zIndex = "";
//       }
//     });

//     observer.observe(cartDrawerContainer, { attributes: true, attributeFilter: ["class"] });
//   }

//   handleProductAdded() {
//     this.triggerVibration(200);

//     requestAnimationFrame(() => {
//       const cartBubble = document.querySelector(".cart-count-bubble span[aria-hidden='true']");
//       if (!cartBubble) return;

//       const itemCount = parseInt(cartBubble.textContent.trim(), 10);
//       const now = Date.now();

//       // Show toast only on odd items
//       if (itemCount % 2 === 1) {
//         this.showToast("✓ Product added to cart", "success", 2000);
//       }

//       // Open drawer on even items
//       if (itemCount % 2 === 0 && now - this.lastOpenedAt > 2000) {
//         const summary = document.querySelector("cart-drawer")?.querySelector("summary");
//         if (summary?.closest("details")?.hasAttribute("open") === false) {
//           summary.click();
//           this.triggerVibration(300);
//           this.lastOpenedAt = now;
//         }
//       }
//     });
//   }

//   showToast(message, type = "success", duration = 2000) {
//     const toast = document.createElement("div");
//     toast.className = `cart-toast cart-toast--${type}`;
//     toast.setAttribute("role", "status");
//     toast.textContent = "Product added to cart";

//     const container = document.querySelector(".toast-container");
//     container.appendChild(toast);

//     requestAnimationFrame(() => toast.classList.add("animated"));

//     setTimeout(() => {
//       toast.classList.add("removing");
//       setTimeout(() => toast.remove(), 300);
//     }, duration);
//   }

//   getVibrationAPI() {
//     return navigator.vibrate?.bind(navigator) ||
//       navigator.webkitVibrate?.bind(navigator) ||
//       navigator.mozVibrate?.bind(navigator) ||
//       navigator.msVibrate?.bind(navigator);
//   }

//   triggerVibration(duration) {
//     this.vibrationAPI?.(duration);
//   }
// }

// customElements.define("cart-even-items-drawer-enhanced", CartEvenItemsDrawerEnhanced);

// // ====================================
// // INJECT STYLES
// // ====================================

// if (!document.querySelector('style[data-toast-styles]')) {
//   const style = document.createElement("style");
//   style.setAttribute("data-toast-styles", "");
//   style.textContent = `
//     .toast-container {
//       position: fixed;
//       bottom: 50px;
//       left: 50%;
//       transform: translateX(-50%);
//       z-index: 99999999999999999999999999999999999999999999999999999999999999999999999999999999999999;
//       display: flex;
//       flex-direction: column;
//       gap: 10px;
//     }

//     .cart-toast {
//       padding: 14px 24px;
//       border-radius: 4px;
//       font-size: 14px;
//       font-weight: 500;
//       background-color: #000;
//       color: #fff;
//       box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
//       opacity: 0;
//       transform: translateY(20px);
//       transition: opacity 0.3s ease, transform 0.3s ease;
//     }

//     .cart-toast.animated {
//       opacity: 1;
//       transform: translateY(0);
//     }

//     .cart-toast.removing {
//       opacity: 0;
//       transform: translateY(20px);
//     }

//     @media (max-width: 640px) {
//       .toast-container {
//         bottom: 100px;
//       }
//       .cart-toast {
//         padding: 12px 16px;
//         font-size: 13px;
//       }
//     }
//   `;
//   document.head.appendChild(style);
// }


// BOGO Auto-Add Script - Check cart items only
(function () {
  const BOGO_TAG = 'bogo-jan-2026';
  const WAIT_TIME = 3000;
  const CHECKOUT_COOLDOWN = 2000;
  const originalCheckout = window.onCheckoutClick;
  let isCheckoutProcessing = false;

  window.onCheckoutClick = async function (buttonElement) {
    if (isCheckoutProcessing) return;

    isCheckoutProcessing = true;
    const loader = buttonElement.querySelector('#btn-loader');
    if (loader) loader.style.display = 'block';
    buttonElement.disabled = true;

    try {
      const cart = await (await fetch('/cart.js')).json();

      if (!cart.items.length) {
        proceedToCheckout(loader, buttonElement);
        return;
      }

      // Get unique product handles and fetch all in parallel
      const productHandles = [...new Set(cart.items.map(item => item.handle))];
      const products = await Promise.allSettled(
        productHandles.map(handle =>
          fetch(`/products/${handle}.js`).then(r => r.json())
        )
      );

      // Filter BOGO products and collect items
      const bogoItems = [];
      products.forEach((result, idx) => {
        if (result.status === 'fulfilled' && result.value.tags?.includes(BOGO_TAG)) {
          const cartItemsForHandle = cart.items.filter(i => i.handle === productHandles[idx]);
          cartItemsForHandle.forEach(item => {
            bogoItems.push({ ...item, product: result.value });
          });
        }
      });

      const bogoQty = bogoItems.reduce((sum, item) => sum + item.quantity, 0);

      // Handle odd quantity by adding cheapest variant
      if (bogoQty > 0 && bogoQty % 2 === 1) {
        const cheapestVariant = findCheapestVariant(bogoItems);

        if (cheapestVariant) {
          // Add item immediately
          await addItemViaAPI(cheapestVariant.id);

          // Update cart drawer in background after 5s (don't wait)
          setTimeout(() => {
            updateCartDrawer();
          }, WAIT_TIME);
        }
      }

      proceedToCheckout(loader, buttonElement);

    } catch (err) {
      proceedToCheckout(loader, buttonElement);
    } finally {
      setTimeout(() => {
        isCheckoutProcessing = false;
        buttonElement.disabled = false;
      }, CHECKOUT_COOLDOWN);
    }
  };

  // Helper function to proceed to checkout
  function proceedToCheckout(loader, buttonElement) {
    if (loader) loader.style.display = 'none';
    if (originalCheckout) {
      originalCheckout(buttonElement);
    } else {
      window.location.href = '/checkout';
    }
  }

  // Helper function for sleep
  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Find cheapest available variant
  function findCheapestVariant(bogoItems) {
    let cheapest = null;
    let minPrice = Infinity;

    for (const item of bogoItems) {
      for (const variant of item.product.variants) {
        if (variant.available && variant.price < minPrice) {
          minPrice = variant.price;
          cheapest = variant;
        }
      }
    }

    return cheapest;
  }

  // Add item via API
  async function addItemViaAPI(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(r => r.ok);
  }

  // Update cart drawer sections
  async function updateCartDrawer() {
    try {
      const parser = new DOMParser();
      const sections = ['mini-cart', 'cart-icon-bubble'];

      // Fetch both sections in parallel
      const results = await Promise.all(
        sections.map(section =>
          fetch(`${window.location.pathname}?section_id=${section}`).then(r => r.text())
        )
      );

      // Update DOM
      results.forEach((html, idx) => {
        const element = document.getElementById(sections[idx]);
        if (element) {
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.querySelector('.shopify-section') || doc.body;
          element.innerHTML = newSection.innerHTML;
        }
      });

      // Refresh drawer if open
      const details = document.querySelector('cart-drawer details[open]');
      if (details) {
        details.removeAttribute('open');
        await sleep(200);
        details.setAttribute('open', '');
      }

      // Dispatch event
      const cartData = await (await fetch('/cart.js')).json();
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: cartData },
        bubbles: true
      }));

      return true;
    } catch (e) {
      return false;
    }
  }

  console.log('✅ BOGO optimized');
})();
document.addEventListener('ajaxProduct:added', function (e) {
  const closeBtn = document.querySelector('.quick-view__close');
  if (closeBtn) {
    closeBtn.click();
  }
});